@if (canAddFiles) {
  <div class="mb-2">
    @if (inputFiles.length > 0) {
      <span class="text-sm font-italic">
        <ng-container i18n="@@chat_line_files_text">Fichiers:</ng-container>
      </span>
    }
    @for (file of inputFiles; track file) {
      <p-chip
        class="m-2"
        [label]="file.filename"
        [removable]="true"
        (onRemove)="removeSelectedFile(file.id)"
      />
    }
    @if (inputContent) {
      <span class="text-sm font-italic">
        <ng-container i18n="@@chat_line_medias_text">Medias:</ng-container>
      </span>
      <p-chip
        class="m-2"
        [label]="inputContent.title"
        [removable]="true"
        (onRemove)="removeSelectedContent()"
      />
    }
  </div>
}
<div class="flex gap-2 items-start">
  @if (canAddFiles) {
    <app-add-context-menu
      (filesSelected)="onFileSelected($event)"
      (contentSelected)="onContentSelected($event)"
    />
  }

  @if (showImageCreationToggle) {
    <span
      [pTooltip]="imageCreationEnabled ? tooltipDisableImageCreation : tooltipEnableImageCreation"
      style="cursor: pointer"
    >
      <button
        class="image-toggle"
        [class.p-button-primary]="imageCreationEnabled"
        [class.p-button-secondary]="!imageCreationEnabled"
        [class.p-button-outlined]="!imageCreationEnabled"
        [class.p-button-icon-only]="true"
        type="button"
        pButton
        (click)="toggleImageCreation()"
        [attr.aria-pressed]="imageCreationEnabled"
        [disabled]="disabled"
      >
        <!-- Visible icon -->
        <i
          class="fa fa-image"
          aria-hidden="true"
        ></i>
        <span class="p-sr-only">
          @if (!imageCreationEnabled) {
            <ng-container i18n="@@chat_input_enable_image_creation">Activer la création d’images</ng-container>
          } @else {
            <ng-container i18n="@@chat_input_disable_image_creation">Désactiver la création d’images</ng-container>
          }
        </span>
      </button>
    </span>
  }

  <!-- Web Search toggle -->
  @if (showSearchToggle) {
    <span
      [pTooltip]="searchEnabled ? tooltipDisableSearch : tooltipEnableSearch"
      style="cursor: pointer"
    >
      <button
        class="search-toggle"
        [class.p-button-primary]="searchEnabled"
        [class.p-button-secondary]="!searchEnabled"
        [class.p-button-outlined]="!searchEnabled"
        [class.p-button-icon-only]="true"
        type="button"
        pButton
        icon="fa fa-globe"
        label=""
        (click)="toggleSearch()"
        [attr.aria-pressed]="searchEnabled"
        [disabled]="disabled"
      ></button>
    </span>
  }

  <!-- Text Area and Send Button -->
  <textarea
    class="w-full"
    style="max-height: 200px; min-height: 44px"
    rows="1"
    pInputTextarea
    [autoResize]="true"
    [(ngModel)]="textAreaInput"
    placeholder="Requête"
    i18n-placeholder="@@chat_input_placeholder"
    [disabled]="disabled"
    (input)="onTextAreaInputChanged($event)"
    (keyup.control.enter)="onEnterControlKey()"
  ></textarea>
  <button
    class="p-button-secondary p-button-outlined no-outline text-2xl align-self-end"
    style="margin-left: auto; border: none"
    type="button"
    pButton
    label=""
    [icon]="genPending ? 'fa fa-stop' : 'fa fa-play'"
    tooltipPosition="top"
    pTooltip="Envoyer (Ctrl-Enter)"
    i18n-pTooltip="@@chat_input_button_tooltip"
    (click)="sendOrStop()"
    [disabled]="disabled || (!genPending && !textAreaInput.trim())"
  ></button>
</div>
